import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { AbandonnerDossier } from "src/app/parametrage/core/model/request/abandonner-dossier";

@Component({
  selector: "app-abandonner-dossier",
  templateUrl: "./abandonner-dossier.component.html",
  styleUrls: ["./abandonner-dossier.component.scss"],
})
export class AbandonnerDossierComponent implements OnInit {
  @Input() requestId;

  form2: FormGroup;
  pressButton: Boolean = false;

  request: Request;

  command: AbandonnerDossier = new AbandonnerDossier();

  errorMessage: String = null;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _requestService: RequestService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      motif: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this.command.requestId = this.requestId;
    this.command.motif = this.form2.value.motif;
    this._requestService
      .abandonner(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.errorMessage = error.error.message;
        }
      );
  }
}
